import axios from 'axios';
import {IContract, IContractAnalyticsResponse, IContractResponse} from "./Contract.types";
import AnalyticsApi from "../Analytics/Analytics.api";

export default class ContractApi {
    static async get({queryKey}) {
        //eslint-disable-next-line
        const [_key, contractId] = queryKey;
        try {
            let res = await axios.get(`/contracts/${contractId}`);
            if (res) {
                return res.data as IContract
            }
        } catch (e) {
            console.log('Error getting contracts', e.message);
            return undefined;
        }
    }

    static async getContractAnalytics({queryKey}) {
        try {
            let topAgencies = await AnalyticsApi.getTopAgencies({queryKey});
            let rankedVendors = await AnalyticsApi.getRankedVendors({queryKey});
            let topCompetitionOptions = await AnalyticsApi.getTopCompetitionOptions({queryKey});
            let topNaics = await AnalyticsApi.getTopNaics({queryKey});
            let topPsc = await AnalyticsApi.getTopPsc({queryKey});
            let topSetAside = await AnalyticsApi.getTopSetAside({queryKey});
            let topStates = await AnalyticsApi.getTopStates({queryKey});

            return {
                topAgencies, rankedVendors, topCompetitionOptions, topNaics, topPsc, topSetAside, topStates
            } as IContractAnalyticsResponse
        } catch (e) {
            console.log('Error getting contract analytics', e.message);
            return undefined;
        }
    }

    static async getContracts({queryKey}) {
        //eslint-disable-next-line
        const [_key, params] = queryKey;
        try {
            let res = await axios.post('/contracts', params);

            if (res) {
                return res.data as IContractResponse
            }
        } catch (e) {
            console.log('Error getting contracts', e.message);
            return undefined;
        }
    }

    static async getWeeklyContracts({queryKey}) {
        //eslint-disable-next-line
        const [_key, userId, page] = queryKey;
        try {
            let res = await axios.post(`/contracts/weekly`, {userId, page});
            if (res) {
                return res.data as IContractResponse
            }
        } catch (e) {
            console.log('Error getting weekly contracts', e.message);
            return undefined;
        }
    }

    static async getWeeklyContractAnalytics({queryKey}) {
        try {
            let topAgencies = await AnalyticsApi.getWeeklyTopAgencies({queryKey});
            let rankedVendors = await AnalyticsApi.getWeeklyRankedVendors({queryKey});
            let topCompetitionOptions = await AnalyticsApi.getWeeklyTopCompetitionOptions({queryKey});
            let topNaics = await AnalyticsApi.getWeeklyTopNaics({queryKey});
            let topPsc = await AnalyticsApi.getWeeklyTopPsc({queryKey});
            let topSetAside = await AnalyticsApi.getWeeklyTopSetAside({queryKey});
            let topStates = await AnalyticsApi.getWeeklyTopStates({queryKey});

            return {
                topAgencies, rankedVendors, topCompetitionOptions, topNaics, topPsc, topSetAside, topStates
            } as IContractAnalyticsResponse
        } catch (e) {
            console.log('Error getting weekly contract analytics', e.message);
            return undefined;
        }
    }
}